// extracted by mini-css-extract-plugin
export default {"gallery":"Products_gallery__ptBJx","products":"Products_products__MQ65o","collapsible":"Products_collapsible__RpJ9X"};